import React from 'react';
import { useState, useRef } from 'react';
import { useData } from '../../DataContext/DataProvider'

/**
 * ShoppingListForm
 * component to add or edit an item within the shopping list
 * used in: ShoppingListElement, ShoppingListPage
 * addItem: function to handle item submission for add (ShoppingListPage) or update (ShoppingListElement)
 * initialItem: the default values for form fields - can be passed blank from ShoppingListPage
 * stopEditing: trigger when cancel or submit is pressed, null function when called from ShoppingListPage
 * 
 * @returns
 */
function ShoppingListForm({initialItem = {
        Item_Name: "",
        Item_Quantity: ""
}, setEditing = () => { } }) {
        const newRef = useRef(null)
    const blankSlate = initialItem
    const [formState, setFormState] = useState(blankSlate)
    const dataContext = useData();
    
    const changeHandler = (e) => {
        const { name, value } = e.target;
        setFormState((previousInput) => ({
            ...previousInput,
            [name]: value
        }));
    }
    const onBlur = (e) => {
        const { name, value } = e.target;
        setFormState((previousInput) => ({
            ...previousInput,
            [name]: value.trim()
        }));
    }

    const submitHandler = (e) => {
        e.preventDefault();
        if (newRef.current.reportValidity()) {
            initialItem.Item_ID ? dataContext.shoppingListData.editShoppingListItem(formState) : dataContext.shoppingListData.addShoppingListItem(formState);
            setFormState(blankSlate)
            setEditing(false);
        }
    }

    const cancelHandler = () => {
        setFormState(blankSlate)
        setEditing(false);
    }

    return (
        <form className="form-container" ref={newRef}>
            <label className="form-element shopping hoverable-element">
                Item:
                <input type="text"
                    id="Item_Name"
                    name="Item_Name"
                    placeholder="Item Name..."
                    onChange={changeHandler}
                    onBlur={onBlur}
                    value={formState.Item_Name}
                    pattern="(?!.*[;]).*"
                    maxLength="45"
                    required />
            </label>
            <label className="form-element shopping hoverable-element">
                Quantity(g):
                <input type="number"
                    id="Item_Quantity"
                    name="Item_Quantity"
                    placeholder="Item Quantity..."
                    onChange={changeHandler}
                    value={formState.Item_Quantity}
                    min="0"
                    max="2,147,483,647"
                    onFocus={e => e.target.select()}
                    required
                />
            </label>
            <div className="form-element button-container hoverable-element">
                <input type="button" className="button submit recipe button" value="Submit" onClick={submitHandler} />
                <input type="button" className="button cancel recipe button" value="Cancel" onClick={cancelHandler} />
            </div>
        </form>
    )
}

export default ShoppingListForm